import { render, staticRenderFns } from "./materialApiKoshaPop.vue?vue&type=template&id=e5482a46"
import script from "./materialApiKoshaPop.vue?vue&type=script&lang=js"
export * from "./materialApiKoshaPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5482a46')) {
      api.createRecord('e5482a46', component.options)
    } else {
      api.reload('e5482a46', component.options)
    }
    module.hot.accept("./materialApiKoshaPop.vue?vue&type=template&id=e5482a46", function () {
      api.rerender('e5482a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/openapi/materialApiKoshaPop.vue"
export default component.exports